import { render, staticRenderFns } from "./ComponentLayout.vue?vue&type=template&id=4240f3ab&scoped=true"
import script from "./ComponentLayout.vue?vue&type=script&lang=js"
export * from "./ComponentLayout.vue?vue&type=script&lang=js"
import style0 from "./ComponentLayout.vue?vue&type=style&index=0&id=4240f3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240f3ab",
  null
  
)

export default component.exports